// extracted by mini-css-extract-plugin
export default {"school":"SchoolOfCode_school__WkD3A","video":"SchoolOfCode_video__Il1Xa","description":"SchoolOfCode_description__kxxLF"};